import React, { useState } from "react";
import NewFormRenderer from "./components/NewFormRenderer";
import newFormSchema from "./data/newFormSchema";
import './App.css';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData) => {
    setLoading(true);
    const businessTypeOptions = [
      { label: "Small Business", value: "Small Business" },
      { label: "Veteran Owned Business", value: "Veteran Owned Business" },
      { label: "Woman-Owned Business", value: "Woman-Owned Business" },
      { label: "Disadvantaged Veteran Owned Business", value: "Disadvantaged Veteran Owned Business" },
      { label: "HubZone", value: "HubZone" },
      { label: "Alaskan Native Corporation (ANC)", value: "Alaskan Native Corporation (ANC)" },
      { label: "Small Disadvantaged Business", value: "Small Disadvantaged Business" },
      { label: "Indian Tribe or Tribally Owned Corporation", value: "Indian Tribe or Tribally Owned Corporation" },
    ];

    const selectedSmallBusinessTypes = formData.businessTypes
      .map((isSelected, index) => (isSelected ? businessTypeOptions[index].value : null))
      .filter((value) => value !== null)
      .join("; ");
    try {
       // Prepare the payload for the Logic App
      const payload = {
        Name_of_your_contact_person_at_MSS_Solutions: formData.contactPerson,
        Company_Name: formData.companyName,
        Address: formData.generalFullAddress,
        Street: formData.street,
        City: formData.city,
        State: formData.state,
        Zip: formData.zip,
        Phone: formData.phone,
        Email: formData.email,
        Website: formData.website,
        Parent_Company: formData.parentCompany,
        Parent_Company_Address: formData.parentAddress,
        President_Name: formData.presidentName,
        President_Phone: formData.presidentPhone,
        President_Email: formData.presidentEmail,
        Other_Contact_Name: formData.otherContactName,
        Other_Contact_Phone: formData.otherContactPhone,
        Other_Contact_Email: formData.otherContactEmail,
        List_current_License_and_include_any_out_of_State: formData.licenseDetails,
        Years_in_Business: formData.yearsInBusiness,
        Average_Annual_Volume: formData.annualVolume,
        Federal_ID_No: formData.federalID,
        DUNS: formData.dunsNumber,
        Primary_NAICS_Code: formData.primaryNAICS,
        Other_NAICS_Code: formData.otherNAICS,
        Ownership: formData.ownershipType,
        State_of_Incorporation: formData.stateOfIncorporation,
        Year_Incorporated: formData.yearIncorporated,
        Small_Business_Classifications: selectedSmallBusinessTypes,
        Has_your_firm_ever_defaulted_on_a_contract: formData.defaultedOnContract,
        Has_your_firm_experienced_reorganization_within_the_past_year: formData.experiencedReorganization,
        Are_there_any_judgments_claims_arbitration_proceedings_or_suits_pending_or_outstanding_against_your_organization_or_its_officers: formData.pendingClaims,
        Has_your_organization_filed_any_lawsuits_or_requested_arbitration_with_regard_to_construction_contracts_within_the_last_five_years: formData.filedLawsuits,
        Within_the_last_five_years_has_any_officer_or_principal_of_your_organization_ever_been_an_officer_or_principal_of_another_organization_when_it_failed_to_complete_a_construction_contract: formData.failureToCompleteContract,
        Total_number_of_employees: formData.totalEmployees,
        Name_of_Safety_DirectorOrOfficer: formData.safetyDirectorName,
        Safety_Information_Company: formData.safetyCompany,
        Safety_Information_Address: formData.safetyAddress,
        Safety_Information_Street: formData.safetyStreet,
        Safety_Information_City: formData.safetyCity,
        Safety_Information_State: formData.safetyState,
        Safety_Information_Zip: formData.safetyZip,
        Safety_Information_Phone: formData.safetyContactPhone,
        Safety_Information_Email: formData.safetyContactEmail,
        Most_Recent_Experience_Modification_Rate: formData.rate1,
        Year_Prior_Experience_Modification_Rate: formData.rate2,
        Two_Years_Experience_Modification_Rate: formData.rate3,
        Does_your_Firm_have_a_written_Safety_Plan: formData.writtenSafetyPlan,
        Has_your_Firm_been_cited_for_any_serious_OSHA_0Yes_0No_violations_in_the_past_three_years: formData.oshaViolations,
        List_violations_and_corrective_action_taken: formData.oshaViolationsCorrectiveMeasures,
        Does_your_Firm_have_a_drug_testing_policy: formData.drugTestPolicy,
        Does_your_company_provide_task_specific_safety_training_for_your_employees: formData.taskSpecificSafetyTraining,
        Can_you_provide_documentation_of_Safety_Training_if_requested: formData.safetyTrainingDocumentation,
        Does_your_company_hold_Site_Safety_Meetings: formData.siteSafetyMeetings,
        How_Often_Does_your_company_hold_Site_Safety_Meetings: formData.howOften,
        Has_your_company_had_a_Workplace_Fatality_in_the_last_three_years: formData.workplaceFatality,
        Does_your_company_have_a_defined_process_for_onboarding_new_employees_that_includes_providing_safety_training: formData.onboardingProcess,
        Most_Recent_OSHA_Incident_rate_for_past_three_years: formData.mostRecent,
        Year_Prior_OSHA_Incident_rate_for_past_three_years: formData.yearPrior,
        Two_Years_Prior_OSHA_Incident_rate_for_past_three_years: formData.twoYearsPrior,
        Bonding_Company_Name: formData.bondingCompanyName,
        Bonding_Company_Address: formData.bondingFullAddress,
        Bonding_Company_Street: formData.bondingStreet,
        Bonding_Company_City: formData.bondingCity,
        Bonding_Company_State: formData.bondingState,
        Bonding_Company_Zip: formData.bondingZip,
        Bonding_Company_Phone: formData.bondingPhone,
        Bonding_Company_Fax: formData.bondingFax,
        Bonding_Contact_Name: formData.contactName,
        Bonding_Phone: formData.contactPhone,
        Bonding_Email: formData.contactEmail,
        Aggregate_Bonding_Capacity_$: formData.aggregateBondingCapacity,
        Single_project_Bonding_Capacity_$: formData.singleProjectBondingCapacity,
        Total_Number_of_Projects_Currently_Bonded: formData.totalProjectsBonded,
        Total_current_Bonding_$: formData.totalCurrentBonding,
        Signature: formData.signature,
        Title: formData.title,
        Status: "Pending"
      };

      // Attach files as base64 if bondingFiles are provided
      const attachmentsBase64 = [];
      if (formData.bondingFiles && formData.bondingFiles.length > 0) {
        for (const file of formData.bondingFiles) {
          const base64File = await convertFileToBase64(file);
          attachmentsBase64.push({
            name: file.name,
            content: base64File,
          });
        }
      }

      // Add attachments to the payload
      payload.attachments = attachmentsBase64;
      // Call the Logic App endpoint
      const response = await fetch('https://subcontractorformdev.azurewebsites.net:443/api/SubcontractorPrequalificationFormProd/triggers/When_a_HTTP_request_is_received/invoke?api-version=2022-05-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=m-d347zEctPUtvzAX6GgEIy11WL0YpJ4t_VUDKy7xN0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Response:', result);
        return true;
      }
      else {
        const errorResult = await response.json();
        console.error('Error:', errorResult);
        return false;
      }
    } catch (error) {
      console.error('Error during form submission:', error);
      toast.error('An error occurred while submitting the form.');
    } finally {
      setLoading(false);
    }
  };

  // Helper function to convert file to base64
  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]); // Remove 'data:*/*;base64,' part
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  return (
    <div className="app-container">
      <div className="logo-container">
        <img src="/MSSLogo.png" alt="App Logo" className="app-logo" />
      </div>
      <hr className="header-divider" />
      <h1 className="form-title">SUBCONTRACTOR PREQUALIFICATION FORM</h1>
      <div className="header-flex-container">
        <h2 className="section-title">Company General Information</h2>
        <span className="current-date">Date: {new Date().toLocaleDateString()}</span>
      </div>

      {/* ToastContainer moved here */}
      <ToastContainer
        position="bottom-center"
        autoClose={3000} // Customize as needed
        hideProgressBar={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        toastClassName="custom-toast" // Apply custom class
      />

      {/* form renderer */}
      <NewFormRenderer
        schema={newFormSchema}
        onSubmit={handleSubmit}
      />

      {/* Loader display */}
      {loading && (
        <div className="loader">
          <div className="spinner"></div>
          <p className="loader-text">Submitting your form...</p>
        </div>
      )}
    </div>
  );
};

export default App;
